import { twMerge } from "tailwind-merge";
import { PaginationDotsBase, type PaginationDotsBaseProps } from "@core/ui";

export type Props = Omit<
  PaginationDotsBaseProps,
  "dotClassName" | "activeDotClassName" | "renderDot"
>;

/**
 * Styled pagination dots component wrapping PaginationDotsBase.
 * Displays clickable dots for navigation between pages/items.
 */
export function PaginationDots({
  totalPages,
  currentPageIndex,
  scrollContainerRef,
  onPageChange,
  className,
  ...props
}: Props) {
  return (
    <PaginationDotsBase
      totalPages={totalPages}
      currentPageIndex={currentPageIndex}
      scrollContainerRef={scrollContainerRef}
      onPageChange={onPageChange}
      className={twMerge("flex justify-center items-center mt-4 gap-2", className)}
      dotClassName="w-2 h-2 rounded-full transition-all duration-100 bg-brand-400 hover:bg-brand-100 border-0 cursor-pointer"
      activeDotClassName="bg-brand-50 scale-125"
      data-testid="pagination-dots"
      {...props}
    />
  );
}

export default PaginationDots;

